import React, { FC, useMemo } from 'react';
import { MemberType, Team } from 'api/models';
import { PlaceholderCreateOrEditModal } from 'components/organisms/placeholders/create-edit-modal';
import { CreatePlaceholderPayloadOpts } from 'queries/placeholder';
import { useCustomerRole, useRolesWithPlaceholderQuery } from 'queries/roles';
import { Option } from '../squad-picker/types';

interface Props {
  handler?: (form) => Promise<Team>;
  onSuccess: (placeholder) => void;
  onCancel: () => void;
  hostClassName?: string;
  placeholders: Option[];
  responsibleTeam?: MemberType[];
  isPrivate?: boolean;
  options?: CreatePlaceholderPayloadOpts;
}

export const PlaceholderCreate: FC<Props> = ({
  onSuccess,
  onCancel,
  handler,
  hostClassName,
  placeholders,
  responsibleTeam,
  isPrivate,
  options,
}) => {
  const { data: roles = [] } = useRolesWithPlaceholderQuery();
  const customerRole = useCustomerRole();
  const placeholdersLookup = placeholders.reduce(
    (prev, _placeholder) => ({
      ...prev,
      [_placeholder.extra.id]: {
        teamId: _placeholder.extra.id,
        teamName: _placeholder.label,
        roleId: _placeholder.roleId,
        teamType:
          _placeholder?.teamType ||
          (_placeholder?.extra as unknown as Team)?.teamType,
      } as Team,
    }),
    {},
  );

  const getRoles = useMemo(() => {
    if (responsibleTeam) {
      return [
        ...(responsibleTeam?.includes(MemberType.Native) ? roles : []),
        ...(responsibleTeam?.includes(MemberType.External)
          ? [customerRole]
          : []),
      ];
    }

    return isPrivate ? roles : [...roles, customerRole];
  }, [customerRole, isPrivate, responsibleTeam, roles]);

  return (
    <PlaceholderCreateOrEditModal
      roles={getRoles}
      placeholders={placeholdersLookup}
      wrapClassName={hostClassName}
      mutationFn={handler}
      save={onSuccess}
      cancel={onCancel}
      {...(options
        ? {
            payloadOptions: options,
          }
        : {})}
    />
  );
};
